module.exports = __webpack_public_path__ + "static/media/menu_icon.b9a65a1a.svg";